










































import { computed, defineComponent, ref } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import { SortType } from "../../types";
import CategoryDeleteConfirmation from "../CategoryDeleteConfirmation";
import VaultRenameCategoryModal from "../VaultRenameCategoryModal";

const menuItems: BaseMenuItem[] = [
  {
    name: "manage",
    text: $t("Manage"),
  },
  {
    name: "rename",
    text: $t("Rename"),
  },
  {
    name: "delete",
    text: $t("Delete"),
  },
];

export default defineComponent({
  name: "VaultMenu",
  components: { BaseMenu, CategoryDeleteConfirmation, VaultRenameCategoryModal, BaseIcon, BaseIconButton },
  props: {
    selectedCategory: { type: Object as () => VaultCategory, required: true },
    selectedSort: { type: String, required: true },
    selectMode: { type: Boolean, default: false },
    categoryFilesLength: { type: Number, default: 0 },
    allFilesUploaded: { type: Boolean, required: true },
    isManagementAvailable: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const showDeleteConfirmation = ref(false);
    const showRenameModal = ref(false);
    const isCategoryContainsFiles = computed<boolean>(() => props.categoryFilesLength > 0);
    const isAvailableSorting = computed<boolean>(() => {
      return props.categoryFilesLength > 1 && props.allFilesUploaded;
    });

    const sortItems = computed<BaseMenuItem[]>(() => [
      {
        name: "sortDesc",
        text: $t("Most recent"),
        selected: props.selectedSort === SortType.LAST_USE_TIME_DESC,
      },
      {
        name: "sortAsc",
        text: $t("Oldest"),
        selected: props.selectedSort === SortType.LAST_USE_TIME,
      },
    ]);

    const items = computed<BaseMenuItem[]>(() =>
      menuItems.filter(item => {
        if (item.name === "manage" && !isCategoryContainsFiles.value) {
          return false;
        }
        if (item.name === "manage" && props.selectedCategory.system && isCategoryContainsFiles.value) {
          return true;
        }

        return !props.selectedCategory.system;
      })
    );

    const onDelete = () => {
      emit("delete:category");
      showDeleteConfirmation.value = false;
    };

    return {
      items,
      sortItems,
      isCategoryContainsFiles,
      isAvailableSorting,
      showDeleteConfirmation,
      onDelete,
      showRenameModal,
    };
  },
});
